<template>
  <div id="app" class="bg-cinza">
    <menu-topo></menu-topo>
    <transition name="tela">
      <router-view />
    </transition>
    <rodape></rodape>
  </div>
</template>

<script>
import menuTopo from "./shared/menuTopo/menuTopo.vue";
import rodape from "./shared/rodape/rodape.vue";
export default {
  components: {
    "rodape": rodape,
    "menu-topo": menuTopo
  },
  name: "App"
};
</script>

<style>
html, body {height:100%;}
.bg-cinza {
  background-color: #eff3f5;
}
#app {
  font-family: "Segoe UI", serif;
  min-height: 100%;
  position: relative;
 
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.fade {
  transition: 0.5s;
}

.tela-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.tela-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.tela-leave {
  transform: translateX(0);
  opacity: 1;
}

.tela-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.tela-enter-active {
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue